import type {
  KinnserSyncStatus,
  RosterCounts,
} from '../../services/api/types.gen';

/** What the agency holds now, for the fill grid's roster rows. */
export type { RosterCounts };

/**
 * The roster counts off a status.
 *
 * Only the one-agency read carries them -- the list draws a row per agency and
 * none of them shows a roster, and a save returns the same shape without them
 * -- so null here means "not this read", which the grid draws as dashes.
 */
export function rosterCounts(
  status: KinnserSyncStatus | null | undefined
): RosterCounts | null {
  return status?.roster ?? null;
}
